import React, { useEffect, useCallback, useState, useRef } from "react";
import { useHistory, useParams } from "react-router-dom";
import Select from "react-select";
import {
    AddedExcel,
    verifEntete,
    checkGrossiste, saveFile
} from "../../Redux/pctReduce";
import { fetchGrossiste } from "../../Redux/grossisteReduce";
import { useDispatch } from "react-redux";
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import { verif } from "./verif";
import { toast, ToastContainer } from "react-toastify";
import { fetchAnnee } from "../../Redux/anneeReduce";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { t } from "react-multi-lang";




function extraction_PCT({ client }) {

    const dispatch = useDispatch();
    const navigate = useHistory();

    const saveTableCalled = useRef(false);
    const [variable, setVariable] = React.useState("");
    const [alert, setAlert] = React.useState(null);
    const [isLoading, setIsLoading] = React.useState(0);
    const [entities, setEntities] = useState([]);
    const [uploadFile, setUploadFile] = React.useState()
    const [boutonClique, setBoutonClique] = useState(false);
    const [fileName, setFileName] = useState("");
    const [month, setmonth] = React.useState(0);
    const [year, setyear] = React.useState(0);
    const [readonly, setreadonly] = React.useState(0);
    const [save, setsave] = React.useState(1)



    const [optionsannee, setanneeOptions] = React.useState([
        {
            value: "",
            label: "veuillez choisir une année",
            isDisabled: true,
            style: "placeholder",
        },
    ]);
    const [optionsmois, setmoisOptions] = React.useState([
        {
            value: "",
            label: "veuillez choisir un mois",
            isDisabled: true,
            style: "placeholder",
        },
    ]);
    const [moisSelect, setmoisSelect] = React.useState({
        value: 0,
        label: "veuillez choisir un mois",
        style: "placeholder",
    });
    const [anneeSelect, setanneeSelect] = React.useState({
        value: 0,
        label: "veuillez choisir une année",
        style: "placeholder",
    });
    const [GrosSelect, setGrossisteSelect] = React.useState([]);
    const [optionGrossiste, setOptionGrossiste] = React.useState([
        {
            value: "",
            label: "Grossiste",
            isDisabled: true,
        },
    ]);



    const getgrossiste = useCallback(async () => {
        var type = await dispatch(fetchGrossiste());
        var entities = type.payload;
        var arrayOption = [];
        entities.forEach((e) => {
            arrayOption.push({ value: e.id, label: e.Raison_sociale });
        });
        setOptionGrossiste(arrayOption);
    }, [dispatch]);



    const notify = (type, msg) => {
        if (type === 1)
            toast.success(<strong>{msg}</strong>);
        else
            toast.error(<strong>{msg}</strong>);
    }


    const verifmois = useCallback(
        async (b) => {

            var entities = [
                { id: 1, nom: "Janvier" }, { id: 2, nom: "Février" }, { id: 3, nom: "Mars" },
                { id: 4, nom: "Avril" }, { id: 5, nom: "Mai" }, { id: 6, nom: "Juin" },
                { id: 7, nom: "Juillet" }, { id: 8, nom: "Aout" }, { id: 9, nom: "septembre" },
                { id: 10, nom: "Octobre" }, { id: 11, nom: "Novembre" }, { id: 12, nom: "Décembre" },
            ]
            var arOption = [];
            arOption.push({ value: 0, label: "veuillez choisir un mois", style: "placeholder" });
            entities.forEach((a) => {
                arOption.push({ value: a.id, label: a.nom });
                if (a.id === b) {
                    setmoisSelect({ value: a.id, label: a.nom });
                    setmonth(a.id);
                }
            });
            setmoisOptions(arOption);
        },
        [dispatch]
    );



    const verifannee = useCallback(
        async (b) => {
            var PP = await dispatch(fetchAnnee());
            var entities = PP.payload;
            var arOption = [];
            arOption.push({ value: 0, label: "veuillez choisir une année", style: "placeholder" });
            const currentYear = new Date().getFullYear();
            entities.forEach((a, index) => {
                arOption.push({ value: a.id, label: a.annee });
                if (currentYear === parseInt(a.annee)) {
                    //if (index === entities.length - 1) {
                    setanneeSelect({ value: a.id, label: a.annee });
                    setyear(a.annee);
                }
            });
            setanneeOptions(arOption);
        },
        [dispatch]
    );



    const fileHandler = (e) => {
        let fileObj = e.target.files[0];
        if (fileObj.name.slice(-5) === ".xlsx" || fileObj.name.slice(-4) === ".xls") {
            setUploadFile(fileObj);
            var str = fileObj.name.replace(/[^a-zA-Z0-9,;\-.!? ]/g, "");
            setFileName(str);
        } else {
            notify(2, "Vérifier votre type de fichier")
        }
    };




    const showTable = useCallback(async () => {
        try {
            if (fileName !== "") {
                const verificationResult = await dispatch(
                    verifEntete({
                        year: year,
                        month: month,
                    })
                );

                if (verificationResult.payload === false) {
                    const arrayBody = await new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = async (e) => {
        try {
            const buffer = e.target.result;

            const workbook = new ExcelJS.Workbook();
            await workbook.xlsx.load(buffer);

            const worksheet = workbook.worksheets[0]; // first sheet

            const rows = [];

            worksheet.eachRow({ includeEmpty: false }, (row) => {
                rows.push(row.values.slice(1)); 
                // slice(1) because ExcelJS row.values starts at index 1
            });

            resolve(verif(rows, month, anneeSelect.label));
        } catch (err) {
            console.error("Parsing error:", err);
            reject(err);
        }
    };

    reader.onerror = (err) => {
        console.error("File reading error:", err);
        reject(err);
    };

    reader.readAsArrayBuffer(uploadFile);
});


                    if (arrayBody.test === false) {
                        notify(2, "Vérifier les champs de votre fichier excel");
                        setTimeout(() => {
                            window.location.reload();
                        }, 1300);
                    } else {
                        checkProd(arrayBody.tabSkandar);
                    }
                } else {
                    notify(2, "Déjà inséré pour ce mois");
                    setreadonly(0);
                    setIsLoading(0);
                    setBoutonClique(false);
                    window.location.reload();
                }
            } else {
                notify(2, "Vérifiez vos données");
            }
        } catch (error) {
            console.error("An error occurred:", error);
        }
    }, [dispatch, fileName, month, year, anneeSelect, uploadFile]);


    const checkProd = useCallback(async (table) => {
        var arrayBody = [];
        dispatch(checkGrossiste({ table }))
            .then((rowsdes) => {
                if (rowsdes !== undefined && rowsdes.payload.arrayNomFinal.length > 0) {
                    var prod = rowsdes.payload.arrayNomFinal;
                    for (var i = 0; i < prod.length; i++) {
                        if (
                            prod[i] !== null &&
                            typeof prod[i] !== "undefined" &&
                            prod[i] !== "undefined"
                        ) {
                            arrayBody.push({
                                idGrossiste: prod[i][2],
                                nomC: prod[i][0],
                                frs: prod[i][3],
                                nom: prod[i][4],
                                refP: prod[i][5],
                                lib: prod[i][6],
                                typeC: prod[i][7],
                                libD: prod[i][8],
                                gouv: prod[i][9],
                                ans: prod[i][10],
                                mois: prod[i][11],
                                qte: prod[i][12],
                            });
                        }
                        else {
                            arrayBody.push({
                                idGrossiste: null,
                                frs: table[i].frs,
                                nom: table[i].nom,
                                refP: table[i].refP,
                                lib: table[i].lib,
                                typeC: table[i].typeC,
                                nomC: table[i].nomC,
                                libD: table[i].libD,
                                gouv: table[i].gouv,
                                ans: table[i].ans,
                                mois: table[i].mois,
                                qte: table[i].qte,
                            });
                        }
                    }
                    notify(1, "Extraction avec succès");
                    setEntities(arrayBody);
                    setIsLoading(2);
                    return arrayBody;
                } else {
                    setEntitiesManque([]);
                    setEntities([]);
                    setIsLoading(0);
                    return [];
                }
            })
            .catch((error) => {
                console.log(error);
                return [];
            });
    }, [dispatch]);



    const saveTable = useCallback(
        async (
            entities,
            year,
            month,
            uploadFile,
            client
        ) => {

            if (!verifierLigne(entities)) {
                return;
            }
            if (saveTableCalled.current) return;
            saveTableCalled.current = true
            const dataArray = new FormData();
            dataArray.append("file", uploadFile);
            dataArray.append("filename", uploadFile.name);
            dispatch(saveFile(dataArray)).then((e) => {
                var filename = e.payload.filename;
                dispatch(
                    AddedExcel({
                        annee: year,
                        mois: month,
                        lignes: entities,
                        filename: filename,
                        type: 10, client
                    })
                ).then((e) => {
                    if (e.payload === true) {
                        setsave(0)
                        notify(1, "Insertion avec succes");
                        setTimeout(() => {
                            window.location.reload();
                        }, 1300);
                    } else {
                        notify(2, "Vérifier vos données!");
                    }
                });
            });

        },
        [dispatch]
    );


    useEffect(() => {
        switch (month) {
            case 1:
                setVariable("JANVIER");
                break;
            case 2:
                setVariable("FEVRIER");
                break;
            case 3:
                setVariable("MARS");
                break;
            case 4:
                setVariable("AVRIL");
                break;
            case 5:
                setVariable("MAI");
                break;
            case 6:
                setVariable("JUIN");
                break;
            case 7:
                setVariable("JUILLET");
                break;
            case 8:
                setVariable("AOUT");
                break;
            case 9:
                setVariable("SEPTEMBRE");
                break;
            case 10:
                setVariable("OCTOBRE");
                break;
            case 11:
                setVariable("NOVEMBRE");
                break;
            case 12:
                setVariable("DECEMBRE");
                break;
            default:
                break;
        }
        verifmois()
        verifannee()
        getgrossiste()
    }, [dispatch]);


    function listeITM() {
        navigate.push(client + "/list_PCT");
    }


    const setTable = useCallback(
        async (table, init) => {
            var arrayBody = [];
            if (init === 1) {
                setEntities((prevEntities) =>
                    prevEntities.map((prev, index) => ({
                        ...prev, // Keep all other existing fields
                        idGrossiste: table[index]?.idGrossiste ?? prev.idGrossiste,
                        nomC: table[index]?.nomC ?? prev.nomC,
                    }))
                );
            } else {
                checkProd(table, year);
            }
        },
        [checkProd]
    );


    const removeGros = useCallback(
        async (list, select, id) => {
            list[id].idGrossiste = null;
            list[id].nomC = null;
            select[id] = null;
            setGrossisteSelect(select);
            setEntities(list);
            setTable(list, 1);
        },
        [setTable]
    );


    function verifierLigne(entities) {
        for (var i = 0; i < entities.length; i++) {
            var line = entities[i];

            if (line.idGrossiste === null) {
                saveTableCalled.current = false
                notify(2, "Veuillez choisir un grossiste " + (i + 1));
                return;
            }
        }
        return true;
    }


const exportToexcel = async (info) => {
    const name = "Exemple excel PCT";
    const currentDate = new Date();
    const formattedDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${currentDate.getDate()
        .toString()
        .padStart(2, '0')}`;

    const fileName = `${name} ${formattedDate}`;

    if (!info || info.length === 0) return;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('data');

    // Define columns based on object keys (stable structure)
    const headers = Object.keys(info[0]);

    worksheet.columns = headers.map((header) => ({
        header: header,
        key: header,
        width: 20,
    }));

    // Add rows
    info.forEach((row) => {
        worksheet.addRow(row);
    });

    // Bold header row
    worksheet.getRow(1).font = { bold: true };

    // Generate buffer
    const buffer = await workbook.xlsx.writeBuffer();

    const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    saveAs(blob, `${fileName}.xlsx`);
};



    return (
        <>
            <Container fluid className="responsive-BL table-dynamique releve-class">
                <ToastContainer />
                {alert}
                <Row>
                    <Col md="12">
                        <Button
                            id="saveBL"
                            className="btn-wd btn-outline mr-1 float-left"
                            type="button"
                            variant="info"
                            onClick={listeITM}
                        >
                            <span className="btn-label">
                                <i className="fas fa-list"></i>
                            </span>
                            {t('list')}
                        </Button>

                    </Col>
                </Row>
                <Col md="12">
                    <Card className="strpied-tabled-with-hover">

                        <Card.Header>
                            <Card.Title as="h3" style={{ textAlign: "center", color: "#0077af" }}><strong>{variable}</strong> </Card.Title>
                            <Row>
                                <Col md="10">
                                    <Card.Title as="h4">PCT</Card.Title>
                                </Col>
                                <Col md="2">
                                    <Button
                                        id="saveBL"
                                        className="btn-wd btn-outline mr-1 float-left"
                                        type="button"
                                        variant="info"
                                        onClick={() => {
                                            exportToexcel([{
                                                "frs": "", "nom": "", "refprod": "", "libelle": "", "typeclient": "",
                                                "nom_client": "", "lib_depot": "", "gouvernorat": "", "annee": "", "mois": "", "qte": ""

                                            }]);
                                        }}
                                    >
                                        <span className="btn-label">
                                            <i className="fas fa-upload"></i>
                                        </span>
                                        Télécharger excel
                                    </Button>
                                </Col>
                            </Row>
                        </Card.Header>
                        <Card.Body>



                            <Row>
                                <Col className="pl-1" md="6">
                                    <Form.Group >
                                        <label>Mois</label>
                                        <Select
                                            placeholder="Mois "
                                            className="react-select primary "
                                            classNamePrefix="react-select"
                                            value={moisSelect}
                                            isDisabled={readonly === 1}
                                            onChange={(value) => {
                                                setmoisSelect(value);
                                                setmonth(value.value);
                                            }}
                                            options={optionsmois}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col className="pl-1" md="6">
                                    <Form.Group >
                                        <label>Année</label>
                                        <Select
                                            placeholder="Année "
                                            className="react-select primary "
                                            classNamePrefix="react-select"
                                            isDisabled={readonly === 1}
                                            value={anneeSelect}
                                            onChange={(value) => {
                                                setanneeSelect(value);
                                                setyear(value.label);
                                            }}
                                            options={optionsannee}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <br></br>
                            <br></br>

                            <div className="text-center" style={{ display: month != 0 ? 'block' : 'none' }}>
                                <Form.Group  >
                                    <Form.Control
                                        id="test"
                                        name="file"
                                        type="file"
                                        accept=".xls, .xlsx"
                                        onChange={(e) => {
                                            fileHandler(e);
                                        }}
                                    ></Form.Control>
                                </Form.Group>
                                {/* <div className="custom-file">
                                        <input
                                            type="file"
                                            className="custom-file-input"
                                            id="inputGroupFile01"
                                            aria-describedby="inputGroupFileAddon01"
                                            isDisabled={readonly === 1}
                                            accept=".xls, .xlsx"
                                            onChange={(e) => {
                                                fileHandler(e);
                                            }}
                                        />
                                        <label className="custom-file-label">{fileName}</label>
                                    </div> */}
                                <br></br>
                                <br></br>
                                <Button
                                    className="btn-wd  mr-1 float-right btn btn-success extraction"
                                    id="blExt"
                                    type="button"
                                    isDisabled={readonly === 1}
                                    style={{ display: readonly === 0 ? 'block' : 'none' }}
                                    variant="info"
                                    onClick={(v) => {
                                        showTable();
                                        setBoutonClique(true)
                                        setIsLoading(1)
                                        setreadonly(1)
                                    }}
                                    disabled={boutonClique}
                                >
                                    <span className="btn-label">
                                        <i className="fas fa-cogs"></i>
                                    </span>
                                    Extraction
                                </Button>
                            </div>




                            <div className="loader-container" style={{ display: isLoading === 1 ? 'block' : 'none' }}>
                                <div className="loader"></div>
                            </div>

                            <Row
                                style={{ display: isLoading === 2 ? 'block' : 'none' }}
                            >

                                <div className="div-sample1"
                                    style={{
                                        overflow: "scroll", height: "500px"
                                    }}
                                >
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>NOM_CLIENT</th>
                                                <th>FRS</th>
                                                <th>NOM</th>
                                                <th>REFPROD</th>
                                                <th>LIBELLE</th>
                                                <th>TYPECLIENT</th>

                                                <th>LIB_DEPOT</th>
                                                <th>GOUVERNORAT</th>
                                                <th>annee</th>
                                                <th>MOIS</th>
                                                <th>QTE</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {entities.map((row, key) => (

                                                <tr key={"tr-" + key}>
                                                    <td >
                                                        {row.idGrossiste !== null ? (
                                                            <Form.Group className="desinationProduit">
                                                                <Form.Control
                                                                    className="green"
                                                                    readOnly
                                                                    value={row.nomC}
                                                                    placeholder="Nom client"
                                                                    type="text"
                                                                />
                                                                <Button
                                                                    onClick={() => {
                                                                        removeGros(entities, GrosSelect, key);
                                                                    }}
                                                                >
                                                                    <i className="fa fa-trash" />
                                                                </Button>
                                                            </Form.Group>
                                                        ) : (
                                                            <div >
                                                                {row.nomC != null ? (
                                                                    <Form.Group className="desinationProduit">
                                                                        <Form.Control
                                                                            className="red"
                                                                            readOnly
                                                                            value={row.nomC}
                                                                            placeholder="Nom client"
                                                                            type="text"
                                                                        />
                                                                        <Button
                                                                            onClick={() => {
                                                                                removeGros(entities, GrosSelect, key);
                                                                            }}
                                                                        >
                                                                            <i className="fa fa-trash" />
                                                                        </Button>
                                                                    </Form.Group>
                                                                ) : (
                                                                    ''
                                                                )}
                                                                <Select
                                                                    className="react-select primary custom-react-select"
                                                                    classNamePrefix="react-select"
                                                                    name="Nomclient"
                                                                    placeholder="Nom client"
                                                                    value={GrosSelect[key]}
                                                                    onChange={(v) => {

                                                                        var e = entities;
                                                                        var select = GrosSelect;
                                                                        e[key].idGrossiste = v.value;
                                                                        e[key].nomC = v.label;
                                                                        select[key] = v;
                                                                        setGrossisteSelect(select);
                                                                        setEntities(e);
                                                                        setTable(e, 1);

                                                                    }}
                                                                    options={optionGrossiste}
                                                                />
                                                            </div>
                                                        )}
                                                    </td>
                                                    <td>
                                                        <Form.Group>
                                                            <Form.Control
                                                                value={row.frs}
                                                                type="text"
                                                                readOnly
                                                            />
                                                        </Form.Group>
                                                    </td>
                                                    <td>
                                                        <Form.Control

                                                            value={row.nom}
                                                            type="text"
                                                            readOnly
                                                        />
                                                    </td>
                                                    <td>
                                                        <Form.Group>
                                                            <Form.Control
                                                                value={row.refP}
                                                                type="text"
                                                                readOnly
                                                            />
                                                        </Form.Group>
                                                    </td>
                                                    <td>
                                                        <Form.Group>
                                                            <Form.Control
                                                                value={row.lib}
                                                                type="text"
                                                                readOnly
                                                            />
                                                        </Form.Group>
                                                    </td>
                                                    <td>
                                                        <Form.Group>
                                                            <Form.Control
                                                                value={row.typeC}
                                                                type="text"
                                                                readOnly
                                                            />
                                                        </Form.Group>
                                                    </td>
                                                    {/* <td style={{width:"100%"}}>
                                                            <Form.Group>
                                                                <Form.Control
                                                                    className={row.idGrossiste !== null ? "green" : "red"}
                                                                    value={row.nomC}
                                                                    type="text"
                                                                    readOnly
                                                                />
                                                            </Form.Group>
                                                        </td> */}

                                                    <td>
                                                        <Form.Group>
                                                            <Form.Control
                                                                value={row.libD}
                                                                type="text"
                                                                readOnly
                                                            />
                                                        </Form.Group>
                                                    </td>
                                                    <td>
                                                        <Form.Group>
                                                            <Form.Control
                                                                value={row.gouv}
                                                                type="text"
                                                                readOnly
                                                            />
                                                        </Form.Group>
                                                    </td>
                                                    <td>
                                                        <Form.Group>
                                                            <Form.Control
                                                                value={row.ans}
                                                                type="text"
                                                                readOnly
                                                            />
                                                        </Form.Group>
                                                    </td>
                                                    <td>
                                                        <Form.Group>
                                                            <Form.Control
                                                                value={row.mois}
                                                                type="text"
                                                                readOnly
                                                            />
                                                        </Form.Group>
                                                    </td>
                                                    <td>
                                                        <Form.Group>
                                                            <Form.Control
                                                                value={row.qte}
                                                                type="text"
                                                                readOnly
                                                            />
                                                        </Form.Group>
                                                    </td>

                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>



                                <Col md="12">
                                    <Button
                                        id="saveBL"
                                        className="btn-wd  mr-1 float-right btn btn-success"
                                        type="button"
                                        variant="info"
                                        style={{ display: save === 1 ? 'block' : 'none' }}
                                        onClick={() =>
                                            saveTable(
                                                entities,
                                                year,
                                                month, uploadFile, client
                                            )
                                        }
                                    >
                                        <span className="btn-label">
                                            <i className="fas fa-check"></i>
                                        </span>
                                        Enregistrer
                                    </Button>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Container >
        </>
    );

}
export default extraction_PCT;
